/**
 * Locked SSE contract for Personal Agent P0.
 * Accepts only {type:text|done|error}; drops unknown types (forward-compat).
 * agentId / threadId / model live on done extras only.
 */

function guideIdOf(parsed) {
  return typeof parsed.guideId === 'string' && /^trn-[a-z0-9-]{1,80}$/.test(parsed.guideId)
    ? parsed.guideId
    : null;
}

export function parseSseDataLine(line) {
  if (typeof line !== 'string') return null;
  const trimmed = line.trim();
  if (!trimmed || trimmed.startsWith(':')) return null;
  let payload = trimmed;
  if (payload.startsWith('data:')) {
    payload = payload.slice(5).trim();
  }
  if (!payload || payload === '[DONE]') return null;
  let parsed;
  try {
    parsed = JSON.parse(payload);
  } catch {
    return null;
  }
  if (!parsed || typeof parsed !== 'object') return null;
  const type = parsed.type;
  if (type === 'text') {
    return {
      type: 'text',
      text: typeof parsed.text === 'string' ? parsed.text : '',
      tab: parsed.tab === 'guides' || parsed.tab === 'ask' ? parsed.tab : null,
      guideId: guideIdOf(parsed),
    };
  }
  if (type === 'done') {
    return {
      type: 'done',
      agentId: parsed.agentId || null,
      threadId: parsed.threadId || null,
      model: parsed.model || null,
      tab: parsed.tab === 'guides' || parsed.tab === 'ask' ? parsed.tab : null,
      guideId: guideIdOf(parsed),
    };
  }
  if (type === 'error') {
    return {
      type: 'error',
      message: typeof parsed.message === 'string' ? parsed.message : 'Assistant error',
    };
  }
  // Drop unknown types — do not require new event kinds.
  return null;
}

/**
 * Consume a fetch Response body as SSE; invoke onEvent for each known frame.
 */
export async function readAssistantSse(response, onEvent) {
  if (!response.body) {
    throw new Error('No SSE body');
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split('\n');
    buffer = parts.pop() || '';
    for (const raw of parts) {
      const frame = parseSseDataLine(raw);
      if (frame) onEvent(frame);
    }
  }
  if (buffer.trim()) {
    const frame = parseSseDataLine(buffer);
    if (frame) onEvent(frame);
  }
}
